import React from 'react';
import PropTypes, { any } from 'prop-types';
import {
  Button,
  Text,
  CheckboxGroup,
  Drawer,
  DrawerBody,
  DrawerHeader,
  DrawerFooter,
  DrawerOverlay,
  DrawerContent,
  DrawerCloseButton,
  Stack,
} from '@chakra-ui/react';

import {
  StyledCheckbox,
  StyledRadioButton,
  StyledRadioGroup,
  HR,
} from '../../management/components/FilterPanel.styles';
import {
  STUDENT_PUBLISH_STATUS_MAP as STATUS_MAP,
  ESSAY_TYPE_MAP,
  // WRITING_CATEGORY_MAP,
} from 'utils/data/options';

function StudentEssayFiterPanel({
  isOpen,
  onClose,
  currentFilters,
  setFilters,
}) {
  const newFilters = { ...currentFilters };

  function statusFilterHandler(status) {
    if (newFilters.statusFilters.includes(status)) {
      newFilters.statusFilters.splice(
        newFilters.statusFilters.indexOf(status),
        1
      );
    } else {
      newFilters.statusFilters.push(status);
    }
  }

  function primaryTypePickHandler(pick) {
    newFilters.type = pick;
  }

  // function categoryPickHandler(pick) {
  //   newFilters.category = pick;
  // }

  function clearFilters() {
    setFilters({ statusFilters: [], levelFilters: [] });
    onClose();
  }

  function applyFilters() {
    setFilters(newFilters);
    onClose();
  }

  return (
    <Drawer isOpen={isOpen} onClose={onClose} placement="right">
      <DrawerOverlay background="rgba(27, 27, 27, 0.4)">
        <DrawerContent maxWidth="375px" padding="64px 24px">
          <DrawerCloseButton />
          <DrawerHeader>Filters</DrawerHeader>
          <DrawerBody d="flex" flexDirection="column">
            <Text fontWeight="bold" mb="16px">
              Primary Type
            </Text>
            <StyledRadioGroup defaultValue={newFilters.type}>
              {Object.entries(ESSAY_TYPE_MAP).map((item) => (
                <StyledRadioButton
                  key={item[0].replace(/ /g, '_')}
                  value={item[0]}
                  onChange={() => primaryTypePickHandler(item[0])}
                >
                  <Text>{item[0]}</Text>
                </StyledRadioButton>
              ))}
            </StyledRadioGroup>
            <HR />
            {/* <Text fontWeight="bold" mb="16px">
              Category
            </Text>
            <StyledRadioGroup defaultValue={newFilters.category}>
              {Object.entries(WRITING_CATEGORY_MAP).map((item) => (
                <StyledRadioButton
                  key={item[0].replace(/ /g, '_')}
                  value={item[0]}
                  onChange={() => categoryPickHandler(item[0])}
                >
                  <Text>{item[0]}</Text>
                </StyledRadioButton>
              ))}
            </StyledRadioGroup>
            <HR /> */}
            <Text fontWeight="bold" mb="16px">
              Publish Status
            </Text>
            <CheckboxGroup defaultValue={newFilters.statusFilters}>
              <Stack direction="column" spacing={1}>
                {Object.entries(STATUS_MAP).map((item) => (
                  <StyledCheckbox
                    iconColor="gray.0"
                    key={item[0].replace(/ /g, '_')}
                    value={item[0]}
                    onChange={() => statusFilterHandler(item[0])}
                  >
                    <Text>{item[0]}</Text>
                  </StyledCheckbox>
                ))}
              </Stack>
            </CheckboxGroup>
          </DrawerBody>
          <DrawerFooter d="flex" justifyContent="space-evenly">
            <Button
              variant="outline"
              colorScheme="green"
              onClick={clearFilters}
            >
              Clear All
            </Button>
            <Button colorScheme="green" onClick={applyFilters}>
              View Results
            </Button>
          </DrawerFooter>
        </DrawerContent>
      </DrawerOverlay>
    </Drawer>
  );
}

StudentEssayFiterPanel.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  currentFilters: PropTypes.arrayOf(any),
  setFilters: PropTypes.func.isRequired,
};

export default StudentEssayFiterPanel;
